import i18n from 'shared/helpers/i18n';

import { Validator, ValidationResult, ValidatorOptions } from './Index';

export function minlength(
    minLength: number,
    options: ValidatorOptions = new ValidatorOptions()
): Validator {
    return {
        options: options,
        validate: (value: any) => {
            return {
                hasError: (value || '').length < minLength,
                errorMessage: options.errorMessage
                    ? options.errorMessage
                    : i18n.t('Minlength', { minLength: minLength }),
            } as ValidationResult;
        },
    };
}
